import { render, staticRenderFns } from "./BadgeIndexPreview.vue?vue&type=template&id=16334822"
import script from "./BadgeIndexPreview.vue?vue&type=script&lang=js"
export * from "./BadgeIndexPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports